(function () {
    'use strict';

    var PagePhotoControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-photo.html',
        controllerAs: 'vm',
        bindings: {
            pageList: '<',
            pageIndex: '<',
            template: '<',
            imgSize: '<',
            imgDpi: '<',
            editorType: '<',
            article:'<',
            product:'<',
            propertyValue:'<',
            onChange: '&'
        },
        controller: ['$scope', 'ModulesService', 'FontManagement', '$timeout', '$http', '$translate', 'MessageService','ThemeClassify','FontXmlsManger','ClipArt','RecommendPics','$stateParams', 'FrameConfigs', '$rootScope', 'Gallery', 'UidService','QiniuToken','$uibModal','ImageService',
            function ($scope, ModulesService, FontManagement, $timeout, $http, $translate, MessageService,ThemeClassify,FontXmlsManger,ClipArt,RecommendPics,$stateParams, FrameConfigs, $rootScope, Gallery, UidService, QiniuToken, $uibModal, ImageService) {
                var vm = this;
                vm.showEditorDialog = true;
                vm.storeId = $stateParams.storeId;
                vm.domain = localStorage.getItem('editor-domain');
                vm.isOutlineBtn = false;
                if(vm.propertyValue.outline && vm.propertyValue.outline.length>0 && (vm.product.pictureType == 'single' || (vm.product.pictureType == 'spread' && vm.pageIndex % 2 == 0))){
                    vm.isOutlineBtn = true;
                }
                QiniuToken.get('get', {}, function (token) {
                    vm.token = token;
                });
                vm.$onChanges = function (data){
                    vm.pages = angular.copy(vm.pageList);
                    vm.levelIndex = 0;
                    vm.menuIndex = 3;
                    vm.elementOn = {
                        index:0,
                        pageIndex:0,
                        name:'',
                        item:null
                    };
                    vm.windowH = $('.page-photo-view3-2').height()*0.9;
                    vm.windowW = $('.page-photo-view3-2').width()*0.9;
                    if(vm.windowH / vm.pages[vm.pageIndex].custom.height >= vm.windowW / vm.pages[vm.pageIndex].custom.width ){
                        vm.pages[vm.pageIndex].custom.ratio = vm.windowW / vm.pages[vm.pageIndex].custom.width;
                    }else {
                        vm.pages[vm.pageIndex].custom.ratio = vm.windowH / vm.pages[vm.pageIndex].custom.height;
                    }
                    vm.pages.forEach(function(page){
                        if (page.levels && page.levels.level) {
                            for (var j = 0; j < page.levels.level.length; j++) {
                                var _level = page.levels.level[j];
                                if (_level.textbox && _level.textbox.editable) {
                                    _level.textbox.lock = false;
                                }
                                if (_level.imageart && _level.imageart.editable) {
                                    _level.imageart.lock = false;
                                }
                            }
                        }
                    })
                    $timeout(function (){
                        pageListDrag1()
                    })
                    classifyInit('BORDER');
                }
                //获取字体
                FontManagement.getAll({family: ""}, function (res) {
                    vm.fontList = angular.copy(res);
                    vm.fontList1 = angular.copy(res);
                    $scope.item = vm.fontList[0];
                    vm.defaultFont = res[0];
                    res.forEach(function (item) {
                        if(item.defaultShow){
                            vm.defaultFont = item;
                        }
                    })
                });
                vm.recommendPics = [];
                RecommendPics.getAllByCondition2({items:[{key: "cancelled", op: "=", value: "false"}],sort: ["seq,asc"]},function(res){
                    if(res && res.data){
                        res.data.forEach(function(item){
                            item.identifier = vm.domain + item.identifier;
                        })
                        vm.recommendPics = res.data;
                    }
                })
                $scope.menuCb = function (item) {
                    vm.menuIndex = item;
                    if (vm.menuIndex != 'backupPages' && vm.menuIndex != 'white') {
                        classifyInit();
                    }
                }
                $scope.editorDialogHide = function () {
                    vm.onChange()
                }
                $scope.save = function (){
                    vm.onChange({text:JSON.parse(JSON.stringify(vm.pages[vm.pageIndex]))});
                }

                $scope.rotateImagebox = function () {
                    imageboxRotate($scope, vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox);
                }
                $scope.imageboxSite = function (item) {
                    if (!vm.pages[vm.pageIndex].levels.level[vm.levelIndex] || vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != 'None') {
                        return
                    }
                    var _imagebox = vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                    if (item == 'center') {
                        _imagebox.image.offsetx = -(_imagebox.image.width * _imagebox.image.scale - _imagebox.geometry.width) / 2 / _imagebox.image.scale;
                        _imagebox.image.offsety = -(_imagebox.image.height * _imagebox.image.scale - _imagebox.geometry.height) / 2 / _imagebox.image.scale;
                    }
                    if (_imagebox.image.offsetx > 0) {
                        _imagebox.image.offsetx = 0;
                    }
                    if (_imagebox.image.offsety > 0) {
                        _imagebox.image.offsety = 0;
                    }
                }
                $scope.cutImagebox = function () {
                    var item = vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale = 1;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.x = 0;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.y = 0;
                    item.bokehtype = 'None';
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                        // $scope.$apply();
                    });
                }
                $scope.fillImagebox = function () {
                    var item = vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale = 1;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.x = 0;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.y = 0;
                    item.bokehtype = 'Transparent';
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                        // $scope.$apply();
                    });
                }

                //文字
                function classifyInit(type) {
                    ThemeClassify.getAllByCondition4({
                        type: type || vm.menuIndex,
                        storeId: vm.storeId
                    }, function (res) {
                        if (vm.menuIndex == 'ClipArt' || vm.menuIndex == 'TECHNIQUE') {
                            vm.clipArts = [];
                            if(vm.template.cliparts && vm.template.cliparts.clipart && vm.template.cliparts.clipart.length>0){
                                vm.clipArts = [{
                                    id: "",
                                    name: $translate.instant("button.recommend"),
                                    seq: 0,
                                    type: "CLIPART",
                                    used: true
                                }]
                            }
                            if(res.data){
                                res.data.forEach(function (item) {
                                    if(item.storeId){
                                        vm.clipArts.push(item)
                                    }
                                })
                                res.data.forEach(function (item) {
                                    if(!item.storeId){
                                        vm.clipArts.push(item)
                                    }
                                })
                            }
                            vm.clipArtsPage = 0;
                            vm.clipArtsList = [];
                            clipArtInit(vm.clipArts[0]);
                        }
                        if (vm.menuIndex == 'FONT') {
                            vm.fontlabels = res.data;
                            vm.fontlabelPage = 0;
                            vm.fontlabelList = [];
                            fontInit(res.data[0])
                        }
                        if (vm.menuIndex == 'RECOMMENDPIC') {
                            vm.recommendClassify = res.data;
                            vm.recommendClassifyItem = res.data[0];
                        }
                        if(vm.menuIndex == 'BORDER' || type === 'BORDER'){
                            vm.borderLabels = res.data;
                            if(vm.template.frameConfigs && vm.template.frameConfigs.frameConfig.length>0){
                                vm.borderLabels.unshift({
                                    cancelled: false,
                                    id: null,
                                    name: $translate.instant("button.recommend"),
                                    seq: '',
                                    storeId: 10,
                                    type: "BORDER",
                                    used: true
                                })
                            }
                            vm.borderPage = 0;
                            vm.borderList = [];
                            if(vm.borderLabels && vm.borderLabels.length>0 && !type){
                                borderInit(vm.borderLabels[0])
                            }
                        }
                    });
                }
                vm.fontList = [];
                vm.fontPage = 0;
                vm.itemsPerPage = 40;
                vm.fontLoading = false;
                vm.fontChooseId = "";
                $scope.showfontdocLabels = false;
                vm.fontlabelCb = fontlabelCb;
                function fontInit(item) {
                    if(!item){
                        return
                    }
                    vm.fontLoading = true;
                    vm.fontChooseId = item;
                    FontXmlsManger.byCondition({
                        items: [
                            {key: "themeClassify.id", op: "=", value: item.id}],
                        page: vm.fontPage,
                        size: vm.itemsPerPage,
                        sort: ["id,desc"]
                    }, function (res, headers) {
                        var _sum = headers('X-Total-Count');
                        vm.fontList = res.data;
                        vm.fontLoading = false;
                        if(vm.fontList.length < _sum){
                            vm.fontFulfill = true;
                        }else {
                            vm.fontFulfill = false;
                        }
                    }, function () {
                        vm.fontLoading = false;
                    })
                }
                function fontlabelCb(item){
                    vm.fontList = [];
                    vm.fontPage = 0;
                    fontInit(item)
                }
                $scope.showMorefontdocLabels = function () {
                    $scope.showfontdocLabels = !$scope.showfontdocLabels;
                }/***********************  素材  ****************************/
                vm.clipArtsList = [];
                vm.clipArtsPage = 0;
                vm.clipArtLoading = false;
                vm.clipArtChooseId = "";
                vm.clipArtCb = clipArtCb;
                function clipArtInit(item) {
                    if(!item){return}
                    vm.clipArtChooseId = item;
                    if(item.id){
                        vm.clipArtLoading = true;
                        ClipArt.byCondition3({
                            items: [
                                {key: "themeClassify.id", op: "=", value: item.id}],
                            page: vm.clipArtsPage,
                            size: vm.itemsPerPage,
                            sort: ["seq,asc"]
                        }, function (res, headers) {
                            var _sum = headers('X-Total-Count');
                            angular.forEach(res.data, function (resp) {
                                var arr = {
                                    name: resp.name,
                                    identifier: vm.domain + resp.identifier,
                                    provider: resp.provider,
                                    themeClassifyName: resp.themeClassifyName,
                                    themeClassifyId: resp.themeClassifyId,
                                    resource: {
                                        identifier: vm.domain + resp.identifier,
                                        provider: resp.provider,
                                    }
                                }
                                vm.clipArtsList.push(arr);
                            })
                            vm.clipArtLoading = false;
                            if(vm.clipArtsList.length < _sum){
                                vm.clipArtFulfill = true;
                            }else {
                                vm.clipArtFulfill = false;
                            }
                        }, function () {
                            vm.clipArtLoading = false;
                        })
                    }else{
                        vm.template.cliparts.clipart.forEach(function (clipart) {
                            var arr = {
                                name: "",
                                identifier: clipart.resource.identifier,
                                provider: "",
                                themeClassifyName: $translate.instant("button.recommend"),
                                themeClassifyId: "",
                                resource: clipart.resource
                            }
                            vm.clipArtsList.push(arr);
                        })
                        vm.clipArtLoading = false;
                    }
                }
                function clipArtCb(item){
                    vm.clipArtsList = [];
                    vm.clipArtsPage = 0;
                    clipArtInit(item)
                }
                $scope.loadMoreClipArt = function () {
                    vm.clipArtsPage++;
                    clipArtInit(vm.clipArtChooseId)
                }

                $scope.isClip = false;
                $scope.clipMoreCb = function(item){
                    $scope.isClip = item;
                }
                //页面元素
                vm.isEditorPageElementBody = true;
                $scope.levelInfo = function (level, index) {
                    var item = "";
                    index = completeIndex(index)
                    var i = index+1;
                    if(level.imagebox){
                        item += $translate.instant("editorCommon.imagebox")
                    }
                    if(level.imageart){
                        item += $translate.instant("editorCommon.imageart")
                    }
                    if(level.textbox){
                        item += level.textbox.text || ""
                    }
                    if(level.textdocument){
                        item += $translate.instant("editorCommon.textdocument")
                    }
                    if(level.calMonthBox){
                        item += $translate.instant("editorCommon.calMonthBox")
                    }
                    if(level.calTitleBox){
                        item += $translate.instant("editorCommon.calTitleBox")
                    }
                    return item
                };
                function levelInfo1(level) {
                    var item = "";
                    if(level.imagebox){
                        item = "imagebox"
                    }
                    if(level.imageart){
                        item = "imageart"
                    }
                    if(level.textbox){
                        item = 'textbox'
                    }
                    if(level.textdocument){
                        item = "textdocument"
                    }
                    if(level.calTitleBox){
                        item = "calTitleBox"
                    }
                    if(level.calMonthBox){
                        item = "calMonthBox"
                    }
                    return item
                };
                $scope.levelDelete = function (index) {
                    var levels = vm.pages[vm.pageIndex].levels.level.splice(completeIndex(index), 1);
                    if(levels && levels[0] && levels[0].imagebox){
                        setLayout();
                    }
                    cookie();
                };
                $scope.levelHidden = function (e, level) {
                    level.isHidden = !level.isHidden;
                    fn(e)
                }

                //页面元素移动
                var isBoxDown = false;
                vm.pageElementW = $('.editor-page-element-title').width();
                vm.pageElementH = $('.editor-page-element-title').height();
                vm.pageElementL = $(window).width() - vm.pageElementW - 160;
                vm.pageElementT = 110;
                $scope.movePageElement = function (e) {
                    fn(e);
                    var x = e.clientX;
                    var y = e.clientY;
                    var l = angular.copy(vm.pageElementL);
                    var t = angular.copy(vm.pageElementT);
                    isBoxDown = true;
                    window.onmousemove = function (e) {
                        if (isBoxDown) {
                            var nx = e.clientX;
                            var ny = e.clientY;
                            var nl = nx - (x - l);
                            var nt = ny - (y - t);
                            if(nl < $("#canvasView").offset().left){
                                nl = $("#canvasView").offset().left
                            }
                            if(nl > ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)){
                                nl = ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)
                            }
                            if(nt < $("#canvasView").offset().top){
                                nt = $("#canvasView").offset().top
                            }
                            if(nt > ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)){
                                nt = ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)
                            }
                            vm.pageElementL = nl;
                            vm.pageElementT = nt;
                            $scope.$apply();
                        }

                    }
                    window.onmouseup = function (e) {
                        isBoxDown = false;
                        e.stopPropagation();
                        $scope.$apply();
                    }
                };
                //页面元素拖拽
                var sort1 = null;
                var sortArray1 = [];
                function pageListDrag1() {
                    $timeout(function () {
                        vm.sortingLevel = angular.copy(vm.pages[vm.pageIndex].levels.level);
                        sort1 = new Sortable(document.getElementById('pageList1'), {
                            swap: false,
                            filter: '.filtered',
                            cancel: ".notDrag",
                            preventOnFilter: true,
                            animation: 150,
                            onMove: function(evt) {
                                // 阻止不可移动项目的拖动
                                return !evt.related.classList.contains('filtered');
                            },
                            onEnd: function (/**Event*/evt) {
                                sortArray1 = [];
                                angular.forEach($('#pageList1').find(".sortingPageView"), function (item, index) {
                                    var page = item.getAttribute("data-page");
                                    sortArray1.push(JSON.parse(page));
                                });
                                if(sortArray1 && sortArray1.length>0){
                                    vm.pages[vm.pageIndex].levels.level = [];
                                    $timeout(function () {
                                        vm.pages[vm.pageIndex].levels.level = angular.copy(sortArray1.reverse());
                                        vm.pages[vm.pageIndex].levels.level.forEach(function (value, index) {
                                            value.seq = index+1;
                                        })
                                        sortArray1 = [];
                                        $scope.editorBodyView();
                                    })
                                }
                            }
                        });
                    })
                }
                $scope.dragCompleteClick = function (e, level, index) {
                    fn(e)
                    elementInit((vm.pages[vm.pageIndex].levels.level.length-1-index),vm.pageIndex,level[levelInfo1(level)],levelInfo1(level));
                };
                vm.completeIndex = completeIndex;
                function completeIndex(index) {
                    return vm.pages[vm.pageIndex].levels.level.length-1-index
                }

                //画布操作

                vm.elementInit = elementInit;
                function elementInit(index,pageIndex,item,name){
                    vm.elementOn = {
                        index:index,
                        pageIndex:pageIndex,
                        name:name,
                        item:item
                    };
                    vm.levelIndex = index;
                    multiSelect();
                    if ($scope && !$scope.$$phase && !$scope.$root.$$phase) {
                        $scope.$apply();
                    }
                }
                //锁定
                $scope.locking = vm.locking = function(e){
                    fn(e);
                    if(vm.elementOn.item){
                        vm.elementOn.item.lock = !vm.elementOn.item.lock;
                        if(vm.elementOn.name === 'imagebox'){
                            vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.lock = vm.elementOn.item.lock;
                        }
                        multiSelect()
                    }
                }
                //缓存每一步
                vm.cookie=cookie;
                vm.cookies=[];
                function cookie(){
                    var _data = angular.copy(vm.pages[vm.pageIndex]);
                    vm.cookies.push(_data);
                }
                $scope.editorBodyView = function(e){
                    if(e){
                        fn(e);
                    }
                    if(!vm.textFont){
                        vm.elementOn = {
                            index:"",
                            pageIndex:"",
                            name:"",
                            item:""
                        };
                        vm.levelIndex = "";
                        vm.isOperationColor = false;
                        vm.isOperationSpacing = false;
                        vm.isOperationDir = false;
                        levelInif();
                    }
                    toolbarStatus();
                }
                $scope.levelInif = vm.levelInif = levelInif;
                function levelInif() {
                    angular.forEach(vm.pages, function (page) {
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.code&&level.code.geometry){
                                level.code.ctrlKey = false;
                            }
                            if(level.imageart){
                                level.imageart.ctrlKey = false;
                            }
                            if(level.imagebox){
                                level.imagebox.exchange = false;
                                level.imagebox.ctrlKey = false;
                            }
                            if(level.textbox){
                                level.textbox.ctrlKey = false;
                            }
                            if (level.textdocument && level.textdocument.geometry) {
                                level.textdocument.ctrlKey = false;
                            }
                            if (level.calMonthBox && level.calMonthBox.geometry) {
                                level.calMonthBox.ctrlKey = false;
                            }
                            if (level.calTitleBox && level.calTitleBox.geometry) {
                                level.calTitleBox.ctrlKey = false;
                            }
                        })
                    })
                    multiSelect();
                }
                
                vm.levelMove = levelMove;
                var cookieCalled = false;
                function levelMove(event, operation) {
                    cookieCalled = false;
                    angular.forEach(vm.pages, function (page) {
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.imageart && level.imageart.ctrlKey && !level.imageart.edit){
                                if(operation == 'transparency'){
                                    level.imageart.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.imageart.lock) {
                                    moveWebdown($scope, event, level.imageart, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if(level.imagebox && level.imagebox.ctrlKey){
                                if(operation == 'transparency'){
                                    level.imagebox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.imagebox.lock) {
                                    moveWebdown($scope, event, level.imagebox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if(level.textbox && level.textbox.ctrlKey){
                                if(operation == 'transparency'){
                                    level.textbox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.textbox.lock) {
                                    moveWebdown($scope, event, level.textbox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if (level.textdocument && level.textdocument.ctrlKey) {
                                if(operation == 'transparency'){
                                    level.textdocument.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.textdocument.lock) {
                                    moveWebdown($scope, event, level.textdocument, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                                if(operation == 'transparency'){
                                    level.calMonthBox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.calMonthBox.lock) {
                                    moveWebdown($scope, event, level.calMonthBox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                                if(operation == 'transparency'){
                                    level.calTitleBox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.calTitleBox.lock) {
                                    moveWebdown($scope, event, level.calTitleBox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                        })
                    })
                }
                vm.multiSelect =multiSelect;
                function multiSelect() {
                    var all = getAllCtrlKeyArray();
                    vm.transparencyBtn = true;//透明度
                    vm.lockingBtn = true;//锁定
                    vm.generBoxBtn = true;//重复生成
                    vm.coverageBtn = true;//图层
                    vm.copyBtn = true;//复制
                    vm.deleteBtn = true;//删除
                    vm.textboxBtn = true;//文字
                    vm.toobarAlignmentBtn = false;//对齐
                    vm.hasImgBtn = false; //裁切交换
                    vm.distribute = false;//分布
                    toolbarStatus()
                    if(all.length>0){
                        vm.textboxBtn = false;
                        vm.lockingBtn = false;
                        vm.coverageBtn = false;
                        vm.deleteBtn = false;
                        if (all.length>1) {
                            vm.toobarAlignmentBtn = true;
                        }
                        if (all.length>2) {
                            vm.distribute = true;
                        }
                        angular.forEach(all, function (level) {
                            if (level.code && level.code.ctrlKey) {
                                vm.transparencyBtn = false;
                            }
                        })
                    }else{
                        if(!vm.elementOn || !vm.elementOn.name || vm.elementOn.name == 'calTitleBox' || vm.elementOn.name == 'calMonthBox'){
                            vm.transparencyBtn = false;
                            vm.lockingBtn = false;
                            vm.coverageBtn = false;
                            vm.copyBtn = false;
                            vm.deleteBtn = false;
                            vm.generBoxBtn = false;
                        }
                        if(vm.elementOn && vm.elementOn.item && vm.elementOn.item.lock){
                            vm.textboxBtn = false;
                            vm.coverageBtn = false;
                            vm.deleteBtn = false;
                        }
                        if(vm.elementOn && vm.elementOn.item && vm.elementOn.name == 'textbox' && !vm.elementOn.item.lock){
                            vm.textboxBtn = true;
                        }
                        if(vm.elementOn && vm.elementOn.name == 'imagebox' && vm.elementOn.item && vm.elementOn.item.image && vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier){
                            vm.hasImgBtn = true;
                        }
                    }
                }
                vm.getAllCtrlKeyArray=getAllCtrlKeyArray;
                function getAllCtrlKeyArray() {
                    var all = [];
                    vm.pages.forEach(function (page) {
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.imageart && level.imageart.ctrlKey){
                                level.imageart.levelI = i;
                                level.imageart.current = 'imageart';
                                all.push(level.imageart);
                            }
                            if(level.imagebox && level.imagebox.ctrlKey){
                                level.imagebox.levelI = i;
                                level.imagebox.current = 'imagebox';
                                all.push(level.imagebox);
                            }
                            if(level.textbox && level.textbox.ctrlKey){
                                level.textbox.levelI = i;
                                level.textbox.current = 'textbox';
                                all.push(level.textbox);
                            }
                            if (level.textdocument && level.textdocument.ctrlKey) {
                                level.textdocument.levelI = i;
                                level.textdocument.current = 'textdocument';
                                all.push(level.textdocument);
                            }
                            if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                                level.calTitleBox.levelI = i;
                                level.calTitleBox.current = 'calTitleBox';
                                all.push(level.calTitleBox);
                            }
                            if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                                level.calMonthBox.levelI = i;
                                level.calMonthBox.current = 'calMonthBox';
                                all.push(level.calMonthBox);
                            }
                        });
                    })
                    return all;
                }
                /***********************  文字  ****************************/
                fontuuid()
                vm.selectFont = '';
                vm.selectFontBtn = fontuuid;
                vm.selectFontName = selectFontName;
                vm.chineseSupport = true;
                function fontuuid(){
                    vm.fontuuid = [];
                    FontManagement.getAll({family: vm.selectFont}, function (res) {
                        vm.fontuuid = res;
                    });
                }
                function selectFontName(item){
                    if(item){
                        for(var i=0;i<vm.fontuuid.length; i++){
                            if(vm.fontuuid[i].uuid == item){
                                return vm.fontuuid[i].family
                            }
                        }
                    }
                }
                $scope.updateTextFont = function (data) {
                    if (data == undefined) {
                        MessageService.error($translate.instant("editorMessage.failedAddText"));
                        return
                    }
                    if (!data.enable) {
                        MessageService.error($translate.instant("editorMessage.fontChange"));
                        return
                    }
                    var text = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox);
                    if (text.lock) {
                        return
                    }
                    vm.fontStyle = [];
                    for(var i=0; i<vm.fontuuid.length; i++){
                        if(vm.fontuuid[i].uuid == data.uuid){
                            for(var j=0; j<vm.fontuuid[i].fontStyles.length; j++){
                                vm.fontStyle.push(vm.fontuuid[i].fontStyles[j].style)
                            }
                        }
                    }
                    text.style.bold = false;
                    text.style.italic = false;
                    if(vm.fontStyle.indexOf('NORMAL') != '-1'){
                        text.style.bold = false;
                        text.style.italic = false;
                    }else {
                        if(vm.fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                            text.style.bold = true;
                            text.style.italic = true;
                        }else {
                            if(vm.fontStyle.indexOf('ITALIC') != '-1'){
                                text.style.italic = true;
                                text.style.bold = false;
                            }
                            if(vm.fontStyle.indexOf('BOLD') != '-1'){
                                text.style.bold = true;
                                text.style.italic = false;
                            }
                        }
                    }
                    text.style.font = data.family;
                    text.fontuuid = data.uuid;
                    text.identifier = vm.domain + data.fontStyles[0].identifier;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.loading = true;
                    FontSupport2(FontManagement, text, function (res) {
                        var msg = res.data;
                        if (res.status == 200) {
                            $timeout(function(){
                                vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.loading = false;
                                if (!msg.success || msg.failed) {
                                    vm.editFailedFont = false;
                                    vm.failedFontArr = null;
                                    MessageService.confirm({
                                        title:$translate.instant("editorMessage.warmPrompt"),
                                        confirm:$translate.instant("button.returnCorrection"),
                                        msg:$translate.instant("editorMessage.pleaseChangeFonts1") + 
                                        '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("editorMessage.pleaseChangeFonts2")
                                    })
                                }else{
                                    text.text = (!msg.passed || msg.passed == "") ? $translate.instant("editorMessage.pleaseEnterText") : msg.passed;
                                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox = text;
                                    vm.editFailedFont = false;
                                    vm.failedFontArr = null;
                                    ModulesService.getFontCSS(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox);
                                    cookie();
                                    $timeout(function () {
                                        sizeHeight()
                                        fontStyle(data.uuid);
                                    },200)
                                }
                            },0)
                        }
                    })
                };
                //添加文字
                $scope.addText = function (size, value) {
                    textboxWebAdd(vm.defaultFont, vm.defaultFont.fontStyles, size, function (_font) {
                        if(value){
                            _font.text = value;
                            _font.value = value;
                        }else{
                            _font.text = $translate.instant("editorCommon.doubleClickType");
                            _font.value = $translate.instant("editorCommon.doubleClickType");
                        }
                        var _level ={
                            seq: vm.pages[vm.pageIndex].levels.level.length+1,
                            textbox: _font
                        }
                        vm.pages[vm.pageIndex].levels.level.push(_level);
                        elementInit(_level.seq-1,vm.pageIndex,_level.textbox,'textbox');
                        $timeout(function () {
                            // vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.width = (Number($("#c-xml-page-material-fontId").width() / (3/4) / vm.pages[vm.pageIndex].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio)) + Number(5));
                            // vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / (3/4) / vm.pages[vm.pageIndex].custom.ratio) * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio) + Number(10);
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.height = (Number($("#c-xml-page-material-fontId").height()) + Number(10));
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.x = (vm.pages[vm.pageIndex].trimbox.width - vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.width) / 2 + vm.pages[vm.pageIndex].trimbox.x;
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.y = (vm.pages[vm.pageIndex].trimbox.height - vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.height) / 2 + vm.pages[vm.pageIndex].trimbox.y;

                            var _num = 0;
                            vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                                if(level.textbox){
                                    _num+=10;
                                }
                            });
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.x += _num/vm.pages[vm.pageIndex].custom.ratio;
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.y += _num/vm.pages[vm.pageIndex].custom.ratio;
                            getFontCSS(FontManagement, vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox, $scope)
                            // sizeHeight();
                            cookie();
                            fontStyle(vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.fontuuid)
                        })
                    })
                }
                vm.fontStyleCb = fontStyle;
                function fontStyle(fontuuid){
                    if(vm.elementOn.name != "textbox"){
                        return
                    }
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    vm.fontStyle = [];
                    for(var i=0; i<vm.fontuuid.length; i++){
                        if(vm.fontuuid[i].uuid == fontuuid){
                            for(var j=0; j<vm.fontuuid[i].fontStyles.length; j++){
                                vm.fontStyle.push(vm.fontuuid[i].fontStyles[j].style)
                            }
                        }
                    }
                    text.style.bold1 = false;
                    text.style.italic1= false;
                    if(vm.fontStyle.indexOf('NORMAL') == '-1'){
                        text.style.normal = false;
                    }else {
                        text.style.normal = true;
                    }
                    if(vm.fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                        text.style.bold1 = true;
                        text.style.italic1= true;
                    }else {
                        if(vm.fontStyle.indexOf('ITALIC') != '-1'){
                            text.style.italic1= true;
                        }
                        if(vm.fontStyle.indexOf('BOLD') != '-1'){
                            text.style.bold1 = true;
                        }
                    }
                }
                vm.sizeHeight = sizeHeight;
                function sizeHeight(){
                    $timeout(function () {
                        var _h = Number($("#c-xml-page-material-fontId1").height());
                        var _w = Number($("#c-xml-page-material-fontId1").width());
                        var _h1 = Number($("#c-xml-page-material-fontId2").height());
                        var _w1 = Number($("#c-xml-page-material-fontId2").width());
                        if(_h<_h1){_h=_h1};
                        if(_w<_w1){_w=_w1};
                        if(vm.elementOn.name == 'textbox') {
                            if(!writingmodeInit(vm.elementOn.item.style.writingmode)){
                                vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.height = _h + Number(10);
                            }
                            if(writingmodeInit(vm.elementOn.item.style.writingmode)){
                                vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.width = _w + Number(10);
                            }
                        }
                    },200)
                }
                function sizeHeight2(textbox){
                    $timeout(function () {
                        var _h = Number($("#c-xml-page-material-fontId1").height()) + Number(10);
                        var _w = Number($("#c-xml-page-material-fontId1").width()) + Number(10);
                        if(!writingmodeInit(vm.elementOn.item.style.writingmode)){
                            textbox.geometry.height = _h;
                        }
                        if(writingmodeInit(vm.elementOn.item.style.writingmode)){
                            textbox.geometry.width = _w;
                        }
                    },200)
                }
                $scope.writingmodeInit = writingmodeInit;
                /***********************  文字end  ****************************/
                /***********************  素材  ****************************/
                //添加素材
                $scope.materialCb = function(item, x, y, isDrop, hotStamp){
                    webAddImageart($scope,$http,item,vm.pages[vm.pageIndex].trimbox, function (_imageart) {
                        if(x && y){
                            _imageart.geometry.x = (x-_imageart.geometry.width/2)/vm.pages[vm.pageIndex].custom.ratio;
                            _imageart.geometry.y = (y-_imageart.geometry.height/2)/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(!isDrop) {
                            var _num = 0;
                            vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                                if (level.imageart) {
                                    _num += 10;
                                }
                            });
                            _imageart.geometry.x += _num / vm.pages[vm.pageIndex].custom.ratio;
                            _imageart.geometry.y += _num / vm.pages[vm.pageIndex].custom.ratio;
                        }
                        _imageart.geometry.width = _imageart.geometry.width/vm.pages[vm.pageIndex].custom.ratio;
                        _imageart.geometry.height = _imageart.geometry.height/vm.pages[vm.pageIndex].custom.ratio;
                        if(vm.menuIndex == 'TECHNIQUE' && hotStamp){
                            _imageart.spotColor = {
                                color: hotStamp.color,
                                code: hotStamp.spotColor,
                                name: hotStamp.value,
                                growMethod: hotStamp.epitaxy,
                                growValue: hotStamp.epitaxyValue,
                                unit: hotStamp.unit,
                                uuid: hotStamp.uuid
                            };
                            _imageart.serviceType = "stamping"
                        }
                        var _level ={
                            seq: vm.pages[vm.pageIndex].levels.level.length+1,
                            imageart: _imageart
                        }
                        vm.pages[vm.pageIndex].levels.level.push(_level);
                        elementInit(_level.seq-1,vm.pageIndex,_level.imageart,'imageart');
                        cookie();
                    })
                }
                window.updateGold = function ($event, hotStampIndex) {
                    $timeout(function () {
                        var hotStamp = (vm.propertyValue.hotStamp || [])[hotStampIndex];
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            MessageService.error($translate.instant("pagePhoto.message.techniqueFormat", {fileType: file.type}));
                            return;
                        }
                        ImageService.backendUploadPics(file, vm.domain, vm.token, function(data){
                            var clipArt = {
                                resource:{
                                    identifier: vm.domain + data.key
                                }
                            }
                            $scope.materialCb(clipArt, null, null, false, hotStamp); // 释放URL对象
                            $scope.$apply();
                        },function(err){
                            MessageService.error($translate.instant("pagePhoto.message.whiteInkSizeMismatch"));
                            $scope.$apply();
                        })
                    })
                };
                /***********************  素材end  ****************************/
                /***********************  文字编辑  ****************************/
                //字体
                vm.isOperationColor = false;
                vm.colorList = [
                    {name: '#000000', id: '#000000'},
                    {name: '#666666', id: '#666666'},
                    {name: '#a8a8a8', id: '#a8a8a8'},
                    {name: '#d9d9d9', id: '#d9d9d9'},
                    {name: '#ffffff', id: '#ffffff'},
                    {name: '#647c6e', id: '#647c6e'},
                    {name: '#ffbd4a', id: '#ffbd4a'},
                    {name: '#fef952', id: '#fef952'},
                    {name: '#99e264', id: '#99e264'},
                    {name: '#36b72a', id: '#36b72a'},
                    {name: '#44d9e5', id: '#44d9e5'},
                    {name: '#c27171', id: '#c27171'},
                    {name: '#2fb3ff', id: '#2fb3ff'},
                    {name: '#b760a6', id: '#b760a6'},
                ];
                $scope.operationColorOpen = function ($event) {
                    vm.isOperationColor = !vm.isOperationColor;
                    fn($event)
                }
                $scope.operationColor = function (item) {
                    vm.elementOn.item.style.color = item.id;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox = vm.elementOn.item;
                }
                $scope.chooseTextColor = function () {
                    vm.elementOn.item.style.color = vm.textColor;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox = vm.elementOn.item;
                    vm.textColor = null;
                }
                fontSizeInit();
                function fontSizeInit(size){
                    var _size = 101;
                    var _size1 = Math.floor(size/2);
                    $scope.fontSizes = [];
                    for (var f = 6; f < _size; f++) {
                        $scope.fontSizes.push(f);
                    }
                    if(_size1 > _size){
                        $scope.fontSizes.push(_size1);
                    }
                }
                var a = null;
                $scope.updateTextSize = function (size) {
                    if (a !== null) {
                        clearTimeout(a)
                    }
                    a = setTimeout(function () {
                        if (size <= 6) {
                            size = 6
                        }
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size = size;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.lineheight = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size;
                        vm.elementOn.item = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                        $timeout(function () {
                            // vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.width = (Number($("#c-xml-page-material-fontId").width() / (3/4) / vm.pages[vm.pageIndex].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio)) + Number(5));
                            // vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / (3/4) / vm.pages[vm.pageIndex].custom.ratio) * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio) + Number(10);
                            if(vm.elementOn.item.geometry.width < ptToPx( vm.elementOn.item.style.size)){
                                vm.elementOn.item.geometry.width = ptToPx( vm.elementOn.item.style.size)+10;
                            }

                            sizeHeight();
                            // $scope.$digest();
                            cookie();
                        })
                    },500)
                }
                vm.isOperationSpacing = false;
                $scope.operationSpacing = function (item) {
                    vm.isOperationSpacing = item;
                    vm.isOperationDir = false;
                    $timeout(function () {
                        var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                        $(".block-width").css({left: text.style.letterspacing});
                        $(".block-height").css({left: text.style.lineheight});
                        vm.template.letterspacing =text.style.letterspacing;
                        vm.template.lineheight = text.style.lineheight;
                    })
                }
                //斜体
                $scope.operationItalic = function () {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    if (text) {
                        if(text.style.italic){
                            if(vm.fontStyle.indexOf('NORMAL') > -1){
                                text.style.italic = false;
                                if (vm.fontStyle.indexOf('BOLD') == '-1') {
                                    text.style.bold = false;
                                }
                            }else{
                                if(text.style.bold){
                                    text.style.italic = false;
                                }
                            }
                        }else{
                            if(vm.fontStyle.indexOf('ITALIC') > -1){
                                text.style.italic = true;
                                if(text.style.bold){
                                    if(vm.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                        text.style.bold = false;
                                    }
                                }else{
                                    // if( vm.fontStyle.indexOf('BOLD_ITALIC') > -1){
                                    //     text.style.bold = true;
                                    // }
                                }
                            }else if (vm.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                                text.style.bold = true;
                                text.style.italic = true;
                            }
                        }
                        $timeout(function () {
                            sizeHeight();
                        },200)
                    }
                }
                //粗体
                $scope.operationBold = function () {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    if (text) {
                        if(text.style.bold){
                            if(vm.fontStyle.indexOf('NORMAL') > -1){
                                text.style.bold = !text.style.bold;
                                if (vm.fontStyle.indexOf('ITALIC') == '-1') {
                                    text.style.italic = text.style.bold;
                                }
                            }else{
                                if(text.style.italic){
                                    text.style.bold = !text.style.bold;
                                }
                            }
                        }else{
                            if(vm.fontStyle.indexOf('BOLD') > -1){
                                text.style.bold = true;
                                if(text.style.italic){
                                    if(vm.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                        text.style.italic = false;
                                    }
                                }else{
                                    // if( vm.fontStyle.indexOf('BOLD_ITALIC') > -1){
                                    //     text.style.italic = true;
                                    // }
                                }
                            }else if (vm.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                                text.style.bold = true;
                                text.style.italic = true;
                            }
                        }
                        $timeout(function () {
                            sizeHeight();
                        },200)
                    }
                }

                // 字/行间距鼠标点击移动
                var spacingW = {};
                var flagSpacing = false
                window.resizeSpacingStart = function (e) {
                    fn(e);
                    var targ = e.target ? e.target : e.srcElement;
                    spacingW.clientX = e.clientX || 0;
                    spacingW.originLeft = targ.offsetLeft;
                    spacingW.value = targ.dataset.value;
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    if (text.lock) {
                        return
                    }
                    flagSpacing = true;
                    document.addEventListener("mousemove", resizeSpacingOn, true);
                    document.addEventListener("mouseup", resizeSpacingEnd, true);
                }

                function resizeSpacingOn(e) {
                    if (flagSpacing) {
                        var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                        var l = spacingW.originLeft + e.clientX - spacingW.clientX;
                        if (spacingW.value == 'height' && l < text.style.size) {
                            l = text.style.size;
                        } else if (spacingW.value == 'width' && l < 0) {
                            l = 0;
                        }
                        if (l > 110) {
                            l = 110
                        }
                        if (spacingW.value == 'width') {
                            $(".block-width").css({left: l});
                            text.style.letterspacing = vm.template.letterspacing = l;
                        } else {
                            $(".block-height").css({left: l});
                            text.style.lineheight = vm.template.lineheight = l;
                        }
                        sizeHeight();
                        // var h = Number($('.selectedBorder').find('.c-xml-page-textboxe-text').height());
                        // text.geometry.height = h / vm.pages[vm.pageIndex].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio) + Number(5);
                        $scope.$digest();
                    }
                }
                function resizeSpacingEnd() {
                    if(flagSpacing){
                        cookie();
                    }
                    spacingW = {}
                    flagSpacing = false;
                    document.removeEventListener("mousemove", resizeSpacingOn, true);
                    document.removeEventListener("mouseup", resizeSpacingEnd, true);
                }
                vm.isOperationDir = false;
                $scope.operationDir = function (item) {
                    vm.isOperationDir = item;
                    vm.isOperationSpacing = false;
                }
                //左对齐
                $scope.operationBarDir = function (item) {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    text.style.align = item;
                }
                //横版
                $scope.textHengban = function () {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    var text1 = angular.copy(text);
                    text.style.writingmode = 'horizontal-tb';
                    text.geometry.width = text1.geometry.height;
                    text.geometry.height = text1.geometry.width;
                }
                //竖版
                $scope.textShuban = function (item) {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    var text1 = angular.copy(text);
                    var _writingmode = angular.copy(text.style.writingmode);
                    text.style.writingmode = item;
                    $timeout(function () {
                        if(writingmodeInit(_writingmode) && writingmodeInit(text.style.writingmode)){
                        }else{
                            text.geometry.width = text1.geometry.height;
                            text.geometry.height = text1.geometry.width;
                        }
                    },200)
                }
                /***********************  文字编辑end  ****************************/

                //删除
                $scope.deleteBox = vm.deleteBox = function ($event) {
                    if(vm.elementOn.item.lock){
                        return;
                    }
                    vm.pages[vm.pageIndex].levels.level.splice(vm.elementOn.index, 1);
                    $scope.editorBodyView();
                    cookie();
                }

                
                //拖拽图片
                $timeout(function () {
                    var content = $(".page-photo-view3-2")[0]
                    if(content){
                        content.ondragenter = ignoreDrag;
                        // 拖动文件的鼠标指针位置放置区之上时发生
                        content.ondragover = ignoreDrag;
                        content.ondrop = drop;
                    }
                },1000)

                window.dragStart = function (event) {
                    var target = event.target;
                    event.dataTransfer.setData("img", target.id);
                    if (target.id.indexOf('dragtargetClipArt') != '-1') {
                        event.dataTransfer.setData("Art", target.dataset.clipart);
                    }
                    $timeout(function () {
                        if(target.id.indexOf('dragtargetRecommendPic')>-1 || target.id.indexOf('dragtargetMask')>-1 || target.id.indexOf('dragtargetFrameConfig')>-1 || target.id.indexOf('dragtargetClipArt')>-1){
                            vm.dragDom = true;
                        }
                    })
                };
                window.dragOn = function(event){
                    $timeout(function () {
                        vm.dragDom = false;
                        $(".imageboxView").removeClass('selected-blue')
                    })
                }
                $timeout(function () {
                    document.body.ondrop = function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                    };
                })
                function ignoreDrag(e) {
                    // 确保其他元素不会取得该事件
                    e.stopPropagation();
                    e.preventDefault();
                    var dataset = e.target.dataset;
                    if ((vm.dragDom && (e.target.nodeName == 'IMG' || ($(e.target).attr('class') && $(e.target).attr('class').indexOf('image-placeholder-class') > -1))&&dataset.imgindex)) {
                        var textIndex = dataset.imgindex;
                        if(vm.dragDom){
                            $(".imageboxView").removeClass('selected-blue')
                            $(".imageboxView"+vm.pageIndex+textIndex).addClass('selected-blue');
                            return
                        }
                    }else{
                        $(".imageboxView").removeClass('selected-blue')
                    }
                }
                vm.replacePageIndex = 0;
                vm.replacePageArrIndex = 0;
                vm.replaceTextIndex = 0;
                vm.replacePageIndex2 = 0;
                function drop(e) {
                    var data = e.dataTransfer.getData("img");
                    $timeout(function () {
                        $(".imageboxView").removeClass('selected-blue');
                        var offsetX= e.clientX;
                        var offsetY= e.clientY;
                        offsetX -= parseFloat($(".page-edit-view").offset().left);
                        offsetY -= parseFloat($(".page-edit-view").offset().top);
                        if(vm.pages[vm.pageIndex].scene){
                            offsetX -= vm.pages[vm.pageIndex].scene.imagebox.geometry.x * vm.pages[vm.pageIndex].custom.ratio;
                            offsetY -= vm.pages[vm.pageIndex].scene.imagebox.geometry.y * vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(vm.dragDom){
                            ignoreDrag(e);
                            //拖拽图片进入占位框
                            if (data.indexOf('dragtargetRecommendPic') != '-1') {
                                var levelIndex = e.target.dataset.imgindex;
                                if(levelIndex){
                                    var item = JSON.parse($('#' + data).attr('data-item'));
                                    replaceImagebox(item,levelIndex);
                                }
                            }
                            
                            // 判读是否是占位框
                            if (data.indexOf('dragtargetMask') != '-1') {
                                var item = $('#' + data).attr('data-item');
                                var imgindex = e.target.dataset.imgindex;
                                if(imgindex == null){
                                    var border = null;
                                    if (data.indexOf('Round') > '-1') {
                                        border = {
                                            shape: 'Ellipse',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                    } else if (data.indexOf('Rectangle') > '-1') {
                                        border = {
                                            shape: 'Rectangle',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                    }else{
                                        border = {
                                            shape: 'Rectangle',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                    }
                                    replaceImagebox1(offsetX, offsetY, JSON.parse(item), border);
                                }else {
                                    vm.levelIndex = imgindex;
                                    var item = JSON.parse($('#' + data).attr('data-item'));
                                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.mask.resource.identifier = item.resource.identifier;
                                    if (data.indexOf('Round') > '-1') {
                                        if(vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border){
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border.shape = 'Ellipse';
                                        }else{
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border= {
                                                shape: 'Ellipse',
                                                radius: {
                                                    lt: 0,
                                                    rt: 0,
                                                    rb: 0,
                                                    lb: 0,
                                                    all: 0,
                                                    filletType: 'Fixed'
                                                },
                                                "edge": {
                                                    top: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    left: 0
                                                },
                                                lineWidth: 0,
                                                type: "Color",
                                                lineType:"solid",
                                                resource: {
                                                    "identifier": '',
                                                    "provider": ''
                                                },
                                                color: '#000000',
                                            };
                                        }

                                        vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.shadow= {
                                            color:'#777777',
                                            x:0,
                                            y:0,
                                            blur:0
                                        }
                                    } else if (data.indexOf('Rectangle') > '-1') {
                                        if(vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border){
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border.shape = 'Rectangle';
                                        }else{
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border= {
                                                shape: 'Rectangle',
                                                radius: {
                                                    lt: 0,
                                                    rt: 0,
                                                    rb: 0,
                                                    lb: 0,
                                                    all: 0,
                                                    filletType: 'Fixed'
                                                },
                                                "edge": {
                                                    top: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    left: 0
                                                },
                                                lineWidth: 0,
                                                type: "Color",
                                                lineType:"solid",
                                                resource: {
                                                    "identifier": '',
                                                    "provider": ''
                                                },
                                                color: '#000000',
                                            };
                                        }

                                        vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border= {
                                            shape: 'Rectangle',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                        vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.shadow= {
                                            color:'#777777',
                                            x:0,
                                            y:0,
                                            blur:0
                                        }
                                    }
                                }
                                $timeout(function () {
                                    cookie();
                                },500)
                            }
                            //边框
                            if (data.indexOf('dragtargetFrameConfig') != '-1') {
                                var item = $('#' + data).attr('data-item');
                                var imgindex = e.target.dataset.imgindex;
                                if(imgindex == null){
                                    var borderList = vm.borderList[$('#' + data).attr('data-index')];
                                    getImageInfo(borderList.resource).then(function (data1) {
                                        var imgZoom = 1;
                                        if (data1.width > data1.height) {
                                            imgZoom = 200 / data1.width
                                        } else {
                                            imgZoom = 200 / data1.height
                                        }
                                        var _w2 = (imgZoom * data1.width) / (1 + borderList.marginLeft / 100 + borderList.marginRight / 100) / vm.pages[vm.pageIndex].custom.ratio;
                                        var _h2 = (imgZoom * data1.height) / (1 + borderList.marginBottom / 100 + borderList.marginTop / 100) / vm.pages[vm.pageIndex].custom.ratio;
                                        var _level = {
                                            imagebox:{},
                                            seq: vm.pages[vm.pageIndex].levels.level.length + Number(1)
                                        }
                                        var _imagebox = {
                                            blurredrectangle:null,
                                            bokehtype:'None',
                                            bokehtypes:'None',
                                            geometry:{
                                                width: _w2,
                                                height: _h2,
                                                x:(offsetX/vm.pages[vm.pageIndex].custom.ratio - _w2 / 2) || 0,
                                                y:(offsetY/vm.pages[vm.pageIndex].custom.ratio - _h2 / 2) || 0
                                            },
                                            image: {
                                                resource: {
                                                    identifier: item.identifier,
                                                    provider: item.provider
                                                },
                                                filterResource: {
                                                    identifier: '',
                                                    provider: ''
                                                },
                                                width: item.width,
                                                height: item.height,
                                                imgSize: item.imgSize,
                                                index: item.seq,
                                                parameter: angular.fromJson(item.parameter),
                                                scale: 1,
                                                angle: 0
                                            },
                                            mask: {
                                                resource:{
                                                    identifier: '',
                                                    provider: '',
                                                }
                                            },
                                            rotation:{
                                                angle: 0
                                            },
            
                                            border: {
                                                shape: borderList.shape || 'Rectangle',
                                                radius: {
                                                    lt: 0,
                                                    rt: 0,
                                                    rb: 0,
                                                    lb: 0,
                                                    all: 0,
                                                    filletType: 'Fixed'
                                                },
                                                "edge": {
                                                    top: borderList.marginTop,
                                                    right: borderList.marginRight,
                                                    bottom: borderList.marginBottom,
                                                    left: borderList.marginLeft
                                                },
                                                lineWidth: 0,
                                                type: "Pic",
                                                resource: {
                                                    "identifier": borderList.img,
                                                    "provider": borderList.provider
                                                },
                                                color: null,
                                            },
                                            transparency:1,
                                            shadow:{
                                                color:'#777777',
                                                x:0,
                                                y:0,
                                                blur:0
                                            },
                                            useradded: true
                                        }
                                        _level.imagebox = _imagebox;
                                        vm.pages[vm.pageIndex].levels.level.push(_level);
                                    })
                                }else {
                                    vm.levelIndex = imgindex;
                                    var borderList = vm.borderList[$('#' + data).attr('data-index')];
                                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border = {
                                        shape: borderList.shape || 'Rectangle',
                                        radius: {
                                            lt: 0,
                                            rt: 0,
                                            rb: 0,
                                            lb: 0,
                                            all: 0,
                                            filletType: 'Fixed'
                                        },
                                        "edge": {
                                            top: borderList.marginTop,
                                            right: borderList.marginRight,
                                            bottom: borderList.marginBottom,
                                            left: borderList.marginLeft
                                        },
                                        lineWidth: 0,
                                        type: "Pic",
                                        resource: {
                                            "identifier": borderList.img,
                                            "provider": borderList.provider
                                        },
                                        color: null,
                                    }
                                }
                                $timeout(function () {
                                    cookie();
                                },500)
                            }
                            //判读是否是素材
                            if (data.indexOf('dragtargetClipArt') != '-1') {
                                var dataIndex = $('#' + data)[0].getAttribute('data-index');
                                $scope.materialCb(vm.clipArtsList[dataIndex], offsetX,offsetY, true);
                                $scope.$apply();
                            }
                        }
                    })
                }
                $scope.addPhoto = function(photos){
                    if(photos && Array.isArray(photos) && photos.length > 0){
                        for(var i=0; i<photos.length; i++){
                            var photo = photos[i];
                            $scope.recommendPicsCb(photo);
                        }
                    }
                }
                
                function replaceImagebox1(offsetX, offsetY, data, border, value){
                    if (!border) {
                        border = {
                            shape: 'Rectangle',
                            radius: {
                                lt: 0,
                                rt: 0,
                                rb: 0,
                                lb: 0,
                                all: 0,
                                filletType: 'Fixed'
                            },
                            "edge": {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            lineWidth: 0,
                            type: "Color",
                            lineType:"solid",
                            resource: {
                                "identifier": ''
                            },
                            color: '#000000',
                        };
                    }
                    var item = angular.copy(data);
                    if(item.type=='picture'){
                        var _level = {
                            imagebox:{},
                            seq: vm.pages[vm.pageIndex].levels.level.length + Number(1)
                        }
                        var _imagebox = {
                            value: value,
                            blurredrectangle:null,
                            bokehtype: angular.copy(vm.article.bokehtype),
                            geometry:{
                                width:0,
                                height:0,
                                x:0,
                                y:0
                            },
                            border: border,
                            shadow:{
                                color:'#777777',
                                x:0,
                                y:0,
                                blur:0
                            },
                            image: {
                                resource: {
                                    identifier: item.identifier,
                                    provider: 'qiniu'
                                },
                                filterResource: {
                                    identifier: '',
                                    provider: 'qiniu'
                                },
                                resourceid:item.sourceId,
                                width: item.width,
                                height: item.height,
                                imageInfo: item.imageInfo,
                                imgSize: item.imgSize,
                                index: item.seq,
                                parameter: angular.fromJson(item.parameter),
                                scale: 1,
                                angle: 0,
                            },
                            transparency:1,
                            mask: {
                                resource:{
                                    identifier: '',
                                    provider: '',
                                }
                            },
                            rotation:{
                                angle: 0
                            }
                        }

                        var w = 200 / vm.pages[vm.pageIndex].custom.ratio;
                        var h = 200 / vm.pages[vm.pageIndex].custom.ratio;
                        var imgR = w/h;
                        var imgR1 = item.width/item.height;

                        if(imgR >= imgR1){
                            _imagebox.geometry.width= h/item.height*item.width;
                            _imagebox.geometry.height= h;
                        }else {
                            _imagebox.geometry.width= w;
                            _imagebox.geometry.height= w/item.width*item.height;
                        }

                        _imagebox.geometry.x = (offsetX/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.width/2);
                        _imagebox.geometry.y = (offsetY/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.height/2);
                        _level.imagebox = _imagebox;
                        addImagebox($http, _level.imagebox, function () {
                            vm.pages[vm.pageIndex].levels.level.push(_level);
                        });
                    }
                    if(item.type=="masking"){
                        var newImg = new Image();
                        newImg.crossOrigin = "Anonymous";
                        newImg.src = (item.resource.identifier.indexOf('http') == -1 ? vm.domain : '') + item.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate';
                        newImg.onload = function () {
                            var _level = {
                                imagebox:{},
                                seq: vm.pages[vm.pageIndex].levels.level.length + Number(1)
                            }
                            var _imagebox = {
                                value: value,
                                blurredrectangle:null,
                                bokehtype: angular.copy(vm.article.bokehtype),
                                geometry:{
                                    width:0,
                                    height:0,
                                    x:0,
                                    y:0
                                },
                                border:border,
                                image: {
                                    resource: {
                                        identifier: '',
                                        provider: ''
                                    },
                                    filterResource: {
                                        identifier: '',
                                        provider: 'qiniu'
                                    },
                                    scale: 1,
                                    angle: 0
                                },
                                mask: {
                                    resource:{
                                        identifier: item.resource.identifier,
                                        provider: 'qiniu',
                                    }
                                },
                                rotation:{
                                    angle: 0
                                },
                                transparency:1,
                                shadow:{
                                    color:'#777777',
                                    x:0,
                                    y:0,
                                    blur:0
                                },
                            };
                            var w = 200 / vm.pages[vm.pageIndex].custom.ratio;
                            var h = 200 / vm.pages[vm.pageIndex].custom.ratio;
                            var imgR = w/h;
                            var imgR1 = newImg.width/newImg.height;

                            if(imgR >= imgR1){
                                _imagebox.geometry.width= h/newImg.height*newImg.width;
                                _imagebox.geometry.height= h;
                            }else {
                                _imagebox.geometry.width= w;
                                _imagebox.geometry.height= w/newImg.width*newImg.height;
                            }
                            _imagebox.geometry.x = (offsetX/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.width/2);
                            _imagebox.geometry.y = (offsetY/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.height/2);
                            _level.imagebox = _imagebox;
                            vm.pages[vm.pageIndex].levels.level.push(_level);
                            $scope.$digest();
                        };
                    }
                }
                $scope.recommendPicsCb = function(item){
                    if(vm.elementOn.name == 'imagebox'){
                        replaceImagebox(item,vm.elementOn.index);
                    }else{
                        vm.pages[vm.pageIndex].levels.level.forEach(function(level,levelIndex){
                            (function(level1,levelIndex1){
                                if (level1.imagebox && level1.imagebox.geometry) {
                                    replaceImagebox(item,levelIndex1);
                                }
                            })(level,levelIndex)
                        })
                    }
                }
                function replaceImagebox(data,levelIndex){
                    var item = angular.copy(data);
                    var _imagebox = vm.pages[vm.pageIndex].levels.level[levelIndex].imagebox;
                    if(!_imagebox.bokehtype){
                        _imagebox.bokehtype = 'None';
                    }
                    _imagebox.whiteInk = null;
                    _imagebox.whiteInk2 = null;
                    _imagebox.image = {
                        resource: {
                            identifier: item.identifier,
                            provider: 'qiniu'
                        },
                        filterResource: {
                            identifier: '',
                            provider: 'qiniu'
                        },
                        offsetx:0,
                        offsety:0,
                        resourceid:item.sourceId,
                        width: item.width,
                        height: item.height,
                        imageInfo: item.imageInfo,
                        imgSize: item.imgSize,
                        index: item.seq,
                        parameter: angular.fromJson(item.parameter),
                        scale: 1,
                        angle: 0,
                    }
                    getBlurredrectangle(_imagebox,vm.pageIndex)
                }
                function getBlurredrectangle(imagebox, index) {
                    var item = imagebox;
                    if(!item.image){
                        return
                    }
                    addImagebox($http, imagebox, function () {
                        var newImg = angular.copy({
                            width: imagebox.image.width,
                            height: imagebox.image.height
                        })
                        if ((imagebox.geometry.width - imagebox.geometry.height) * (newImg.width - newImg.height) < 0) {
                            if (index % 2 === 0){
                                if(imagebox.flip){
                                    imagebox.image.angle = imagebox.image.angle+90;
                                }else{
                                    imagebox.image.angle = imagebox.image.angle-90;
                                }
                                imagebox.image.width = newImg.height;
                                imagebox.image.height = newImg.width;
                            }
                            if (index % 2 === 1){
                                if(imagebox.flip){
                                    imagebox.image.angle = imagebox.image.angle-90;
                                }else{
                                    imagebox.image.angle = imagebox.image.angle+90;
                                }
                                imagebox.image.width = newImg.height;
                                imagebox.image.height = newImg.width;
                            }
                        } else {
                            imagebox.image.angle = imagebox.image.angle;
                        }
                        getBackgroundSource3(imagebox, imagebox.geometry.width, imagebox.geometry.height, imagebox.image, imagebox.bokehtype, $scope);
                    },true);
                }
                $scope.layoutCb = function(item){
                    if(!item.config || !item.config.partid){
                        MessageService.error($translate.instant("pagePhoto.message.layoutError"));
                        return
                    }
                    if(vm.pages[vm.pageIndex].config.partid!=item.config.partid){
                        MessageService.error($translate.instant("editorMessage.不是相同部件的版式不可替换"));
                        return
                    }
                    if(item.uuid != vm.pages[vm.pageIndex].uuid){
                        vm.threeLoading = true;
                        vm.threeLoadingText = $translate.instant("editorCommon.loadingText1");
                        item.config = vm.pages[vm.pageIndex].config;
                        var pages = {
                            config:vm.template.config,
                            pages:{
                                page: [angular.copy(item)]
                            }
                        }
                        documentAnalysis($scope, $http, vm, pages,FontManagement,'processing', function(page){
                            if(vm.windowH / page.custom.height >= vm.windowW / page.custom.width ){
                                page.custom.ratio = vm.windowW / page.custom.width;
                            }else {
                                page.custom.ratio = vm.windowH / page.custom.height;
                            }
                        }, function () {
                            $timeout(function () {
                                var layoutPage = pages.pages.page[0];
                                layoutPage.backup = false;
                                layoutPage.unreplace = false;
                                layoutPage.quantity = vm.pages[vm.pageIndex].quantity;
                                pageDataInfo(layoutPage)
                            },200)
                        })
                    }
                }
                function pageDataInfo(page) {
                    vm.threeLoading = true;
                    vm.threeLoadingText = $translate.instant("editorCommon.loadingText1");
                    page.uuid = getUuid();
                    var _pageData = angular.copy(vm.pages[vm.pageIndex]);
                    var _pageDataImageboxImage = [];
                    var _pageDataImageboxImageSum = 0;
                    for(var i=0; i<_pageData.levels.level.length; i++){
                        var _lecel = _pageData.levels.level[i];
                        if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                            _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                            _pageDataImageboxImage.push(_lecel.imagebox)
                        }
                    }
                    if(!page.levels.level){
                        page.levels.level=[];
                    }
                    _pageDataImageboxImage = imageboxAdapt(page.levels.level, _pageDataImageboxImage);
                    angular.forEach(page.levels.level, function (level, i) {
                        if (level.imagebox) {
                            var _imagebox = null;
                            for(var j=0; j<_pageDataImageboxImage.length; j++){
                                if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                                    _imagebox = _pageDataImageboxImage[j];
                                    break
                                }
                            }
                            _pageDataImageboxImageSum++;
                            if (_imagebox) {
                                level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                                level.imagebox.whiteInk = null;
                                level.imagebox.whiteInk2 = null;
                                level.imagebox.image = {
                                    blurredrectangle: {
                                        width: 0,
                                        height: 0,
                                        x: 0,
                                        y: 0
                                    },
                                    resource: {
                                        identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                        provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                                    },
                                    resourceid:_imagebox ? _imagebox.image.resourceid : '',
                                    filterResource: {
                                        identifier: '',
                                        provider: 'qiniu'
                                    },
                                    angle: 0,
                                    offsetx: 0,
                                    offsety: 0,
                                    imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                                    width: _imagebox ? _imagebox.image.width : '',
                                    height: _imagebox ? _imagebox.image.height : '',
                                    imgSize: _imagebox ? _imagebox.image.imgSize : '',
                                    index: _imagebox ? _imagebox.image.seq : '',
                                    parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                                    scale: 1,
                                    brightness:_imagebox ?_imagebox.image.brightness : 0,
                                    contrast: _imagebox ?_imagebox.image.contrast : 0,
                                    saturate: _imagebox ?_imagebox.image.saturate : 0,
                                    temperature: _imagebox ?_imagebox.image.temperature : 0,
                                    hue: _imagebox ?_imagebox.image.hue : 0
                                }
                                if (level.imagebox.image.resource.identifier) {
                                    getBlurredrectangle(level.imagebox,(vm.pageIndex % 2 === 0 ? 0 : 1))
                                }
                            } else {
                                level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                                level.imagebox.whiteInk = null;
                                level.imagebox.whiteInk2 = null;
                                level.imagebox.image = {
                                    resource: {
                                        identifier: '',
                                        provider: ''
                                    },
                                    resourceid:"",
                                    filterResource: {
                                        identifier: '',
                                        provider: ''
                                    },
                                    width: '',
                                    height: '',
                                    imgSize: '',
                                    offsetx: 0,
                                    offsety: 0,
                                    index: '',
                                    parameter: [],
                                    scale: 1,
                                    angle: 0,
                                }
                            }
                        }
                    })
                    $timeout(function () {
                        vm.pages[vm.pageIndex] = page;
                        vm.pages[vm.pageIndex].backup = false;
                        vm.pages[vm.pageIndex].unreplace = false;
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        MessageService.success($translate.instant("editorMessage.formatReplacementSucceeded"));
                    },200)
                }
                /***********************  边框  ****************************/
                vm.borderUnfold = false;
                $scope.bordersCb = function(label, index){
                    vm.borderId = label;
                    vm.borderPage = 0;
                    vm.borderList = [];
                    borderInit(vm.borderId);
                }
                $scope.loadMoreBorder = function () {
                    vm.borderPage++;
                    borderInit(vm.borderId);
                }
                function borderInit(item){
                    vm.borderId = item;
                    if(!vm.borderId){
                        angular.forEach(vm.template.frameConfigs.frameConfig, function (data) {
                            vm.borderList.push(data);
                        })
                        return
                    }
                    vm.borderLoading = true;
                    FrameConfigs.byCondition3({
                        items: [{key: "themeClassify.id", op: "=", value: item.id},{key: "enable", op: "=", value: true},{key: "status", op: "=", value: 'Approved'}],
                        page: vm.borderPage,
                        size: vm.itemsPerPage,
                        sort: ["seq,asc"]
                    }, function (res, headers) {
                        vm.borderLoading = false;
                        angular.forEach(res.data, function (resp) {
                            vm.borderList.push(resp);
                        })
                        var _sum = headers('X-Total-Count');
                        if(vm.borderList.length < _sum){
                            vm.borderFulfill = true;
                        }else {
                            vm.borderFulfill = false;
                        }
                    }, function () {
                    })
                }
                /***********************  边框end  ****************************/
                /***********************  背景  ****************************/
                
                $scope.backgroundColor = function(color){
                    vm.pages[vm.pageIndex].background.color = color ? color : null;
                    vm.pages[vm.pageIndex].background.type = "Color";
                    vm.pages[vm.pageIndex].background.resource.identifier = "";
                    vm.pages[vm.pageIndex].background.resource.provider = '';
                    vm.pages[vm.pageIndex].background.offsetx = 0;
                    vm.pages[vm.pageIndex].background.offsety = 0;
                    cookie();
                }
                $scope.backgroundImage = function(data){
                    vm.pages[vm.pageIndex].background.type = "Pic";
                    vm.pages[vm.pageIndex].background.resource.identifier = data.identifier;
                    vm.pages[vm.pageIndex].background.resource.provider = data.provider;
                    vm.pages[vm.pageIndex].background.offsetx = 0;
                    vm.pages[vm.pageIndex].background.offsety = 0;
                    vm.pages[vm.pageIndex].background.imageInfo = null;
                    getBackgroundSource($http,vm.pages[vm.pageIndex].background.resource, vm.pages[vm.pageIndex].trimbox.width, vm.pages[vm.pageIndex].trimbox.height, vm.pages[vm.pageIndex].background, function () {
                        cookie();
                    })
                }
                /***********************  背景end  ****************************/
                /***********************  顶部操作  ****************************/
                function toolbarStatus(){
                    vm.isTransp = false;
                    vm.isRoundedSet = false;
                    vm.isBorderSet = false;
                    vm.isShadowSet = false;
                    vm.isCoverage = false;
                    vm.isAlign = false;
                    vm.isOperationSpacing = false;
                    vm.isOperationDir = false;
                    vm.isOperationColor = false;
                }
                // 圆角设置
                vm.isRoundedSet = false;
                $scope.roundedSet = function(attr){
                    toolbarStatus();
                    vm.borderRadiusAllbtn = false;
                    vm.isRoundedSet = attr;
                }
                $scope.changeFilletType = function(type){
                    if (vm.elementOn.item.border.radius.filletType == type) {
                        return
                    }
                    vm.elementOn.item.border.radius.filletType = type;
                    switchToRoundedMode(vm.elementOn.item,vm.borderRadiusAllbtn);//切换圆角显示模式
                }
                vm.borderRadiusAllbtn = false
                $scope.borderRadiusAll = function () {
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rt = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                }
                $scope.borderRadiusAllbtn = function(){
                    vm.borderRadiusAllbtn = true;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rt = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt
                }
                // 边框设置
                vm.isBorderSet = false;
                $scope.borderSet = function(attr){
                    toolbarStatus();
                    vm.isBorderSet = attr;
                }
                $scope.lineTypeChenge = function(lineType){
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.lineType = lineType;
                }
                // 阴影设置
                vm.isShadowSet = false;
                $scope.shadowSet = function(attr){
                    toolbarStatus();
                    vm.isShadowSet = attr;
                }
                //图片优化
                vm.showCanvasImageFilter = false;
                // 图片优化
                $scope.optimizationSelect = function (attr) {
                    if (!vm.elementOn.name=='imagebox') {
                        MessageService.error($translate.instant("editorMessage.请选中一个照片"));
                        return
                    }
                    if(vm.elementOn.item.image && vm.elementOn.item.image.resourceid) {
                        // 获取原图信息
                        Gallery.getOne({id:vm.elementOn.item.image.resourceid},function (res){
                            vm.elementOn.item.image.resource.primary = res.data.identifier;
                            // 图片优化
                            if (vm.elementOn.item.image && vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier) {
                                toolbarStatus();
                                var current = vm.elementOn.item;
                                if (current.image) {
                                    vm.showCanvasImageFilter = true;
                                    if(vm.elementOn.item.optimizations){
                                        vm.optimizations = vm.elementOn.item.optimizations;
                                    }
                                } else {
                                    MessageService.error($translate.instant("editorMessage.请选择一个相框"));
                                }
                            }
                        })
                    }
                }

                $rootScope.$on('editorApp.closeImageFilter', function () {
                    vm.showCanvasImageFilter = false;
                });
                $rootScope.$on('editorApp.saveImageFilter', function (event,imgUrl) {
                    vm.showCanvasImageFilter = false;
                    filterImgUpdate(imgUrl);
                });

                function filterImgUpdate(img){
                    vm.elementOn.item.imageLoading = true;
                    QiniuToken.uploadThumbnail(img, function (data) {
                        $.ajax({
                            type: "GET",
                            url: vm.elementOn.item.image.resource.identifier + "?imageInfo",
                            async: false,
                            success: function (va) {
                                var identifier = vm.domain + data.key;
                                vm.elementOn.item.image.resource.identifier = identifier;
                                vm.elementOn.item.imageLoading = false;
                                cookie();
                                $timeout(function() {
                                    vm.elementOn.item.imageLoading = false;
                                })
                                if(va.orientation){
                                    imageboxImgInit();
                                }
                            }
                        })
                    });
                }
                function imageboxImgInit(){
                    $.ajax({
                        type: "GET",
                        url: vm.domain + vm.elementOn.item.image.resource.primary + "?imageInfo",
                        async: false,
                        success: function (va1) {
                            var angle = (vm.elementOn.item.image.angle + 360 - orientationInit1(va1.orientation).angle) % 360;
                            if (vm.elementOn.item.flip) {
                                vm.elementOn.item.image.angle = -angle;
                                vm.elementOn.item.flip = false;
                            }else{
                                vm.elementOn.item.image.angle = angle;
                            }
                        }
                    });
                }
                // 透明度
                vm.isTransp = false;
                $scope.transparencySelect = function () {
                    toolbarStatus()
                    if(!vm.isTransp && vm.elementOn.name !='imageart' && vm.elementOn.name !='textbox' && vm.elementOn.name !='imagebox' ){
                        MessageService.error($translate.instant("editorMessage.pleaseChooseLevel1"));
                        return
                    }
                    vm.isTransp = !vm.isTransp;
                    if(vm.isTransp){
                        var _transparency = 0;
                        if(vm.elementOn.name =='imagebox'){
                            _transparency = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.transparency || 1;
                        }
                        if(vm.elementOn.name =='imageart'){
                            _transparency = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imageart.transparency || 1;
                        }
                        if(vm.elementOn.name =='textbox' ){
                            _transparency = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.transparency || 1;
                        }
                        $timeout(function () {
                            $(".text-range-140").val(_transparency);
                            $(".transparency-num").val(_transparency * 100);
                            vm.transparency = _transparency * 100;
                        })
                    }
                }
                var elem = document.querySelector('input[type="range"]');
                var rangeValue = function () {
                    $(".transparency-num").val(elem.value * 100);
                    vm.transparency = elem.value * 100;
                    var all = getAllCtrlKeyArray();
                    if(all.length>0){
                        levelMove(null, 'transparency')
                    }else{
                        transparencyInit();
                    }
                    $scope.$apply();
                };
        
                elem.addEventListener("input", rangeValue);
                $scope.transparencyChange = function () {
                    if (vm.transparency > 100) {
                        MessageService.error($translate.instant("editorMessage.transparencyInvalid"));
                        vm.transparency = 100;
                    }
                    if (vm.transparency < 0) {
                        MessageService.error($translate.instant("editorMessage.transparencyInvalid"));
                        vm.transparency = 0;
                    }
                    transparencyInit(vm.transparency)
                }
                function transparencyInit() {
                    if(vm.elementOn.name =='imagebox'){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.transparency = vm.transparency/100;
                        return
                    }
                    if(vm.elementOn.name =='imageart'){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imageart.transparency = vm.transparency/100;
                        return
                    }
                    if(vm.elementOn.name =='textbox' ){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.transparency = vm.transparency/100;
                        return
                    }
                }
                // 单个元素对齐
                vm.isAlign = false;
                $scope.alignHover2 = function () {
                    if(vm.elementOn.name == ''){
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAElement"));
                        return
                    }
                    toolbarStatus();
                    vm.isAlign = !vm.isAlign;
                }

                $scope.singleBoxAlignment = function (attr) {
                    if(vm.toobarAlignmentBtn){
                        $scope.boxAlignment(attr);
                        return
                    }
                    if (vm.elementOn.item.lock) {
                        MessageService.error($translate.instant("editorMessage.pleaseSelectALock"));
                        return
                    }
                    if (attr == 'left') {
                        vm.elementOn.item.geometry.x = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'left' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'right') {
                        vm.elementOn.item.geometry.x = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'right' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'top') {
                        vm.elementOn.item.geometry.y = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'top' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'bottom') {
                        vm.elementOn.item.geometry.y = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'bottom' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'vertical') {
                        vm.elementOn.item.geometry.y = (vm.pages[vm.pageIndex].custom.height - vm.elementOn.item.geometry.height) / 2;
                    } else {
                        vm.elementOn.item.geometry.x = (vm.pages[vm.pageIndex].custom.width - vm.elementOn.item.geometry.width) / 2;
                    }
                    cookie()
                }
                $scope.boxAlignment = function (attr) {
                    var levels = vm.pages[vm.pageIndex].levels;
                    var all = getAllCtrlKeyArray();
                    if (attr == 'left') {
                        all.sort(compare2('x', true));
                    } else if (attr == 'right') {
                        all.sort(compare2('width', false));
                        all.sort(compare2('x', false));
                    } else if (attr == 'top') {
                        all.sort(compare2('y', true));
                    } else if (attr == 'bottom') {
                        all.sort(compare2('height', false));
                        all.sort(compare2('y', false));
                    }
                    if(attr == 'vertical' && all.length>0){
                        var verticalY = horizontalAndVerticalCenter(attr, all);
                    }
                    if(attr == 'standard' && all.length>0){
                        var standardX = horizontalAndVerticalCenter(attr, all);
                    }
        
                    for (var i = 0; i < all.length; i++) {
                        if(!all[i].lock){
                            if (attr == 'left') {
                                all[i].geometry.x = all[0].geometry.x;
        
                            } else if (attr == 'right') {
                                all[i].geometry.x = all[0].geometry.x + all[0].geometry.width - all[i].geometry.width;
        
                            } else if (attr == 'top') {
                                all[i].geometry.y = all[0].geometry.y;
        
                            } else if (attr == 'bottom') {
                                all[i].geometry.y = all[0].geometry.y + all[0].geometry.height - all[i].geometry.height;
        
                            } else if (attr == 'vertical') {
                                all[i].geometry.y = verticalY - all[i].geometry.height / 2;
                            } else {
                                all[i].geometry.x = standardX - all[i].geometry.width / 2;
                            }
        
        
                            if (all[i].current == 'imagebox') {
                                levels.level[all[i].levelI].imagebox = all[i];
                            } else if (all[i].current == 'textbox') {
                                levels.level[all[i].levelI].textbox = all[i];
                            } else {
                                levels.level[all[i].levelI].imageart = all[i];
                            }
                        }
                    }
                    // levelInif()
                    cookie()
                }
                // 元素水平垂直分布
                vm.isDistributeHover = false;
                $scope.distribute = function(){
                    vm.isDistributeHover = !vm.isDistributeHover;
                    vm.isAlignHover = false;
                }
                $scope.boxDistribute = function (direction){
                    var all1 = getAllCtrlKeyArray();
                    var all = [];
                    all1.forEach(function(box){
                        if (!box.lock) {
                            all.push(box)
                        }
                    })
                    if (all.length < 3) {
                        MessageService.error($translate.instant("editorMessage.请选择3个以上非锁定状态的元素"));
                        return
                    }
                    if(direction == 'horizontal'){
                        setAllCtrlKeyArray(all, 'x')
                    }
                    if(direction == 'vertical'){
                        setAllCtrlKeyArray(all, 'y')
                    }
                }
                function setAllCtrlKeyArray(all, attr) {
                    var len = all.length - 1;
                    all.sort(compare2(attr, true));
                    if (attr == 'x') {
                        var elementAllWidth = 0;
                        for (var i = 1; i < len; i++) {
                            elementAllWidth+=all[i].geometry.width;
                        }
                        var spacingPx = (all[len].geometry.x - all[0].geometry.x - all[0].geometry.width - elementAllWidth) / len;
                        for (var i = 1; i < len; i++) {
                            all[i].geometry.x = all[i-1].geometry.x + all[i-1].geometry.width + spacingPx;
                        }
                    }
                    if (attr == 'y') {
                        var elementAllHeight = 0;
                        for (var i = 1; i < len; i++) {
                            elementAllHeight+=all[i].geometry.height;
                        }
                        var spacingPx = (all[len].geometry.y - all[0].geometry.y - all[0].geometry.height - elementAllHeight) / len;
                        for (var i = 1; i < len; i++) {
                            all[i].geometry.y = all[i-1].geometry.y + all[i-1].geometry.height + spacingPx;
                        }
                    }
                }
                //图层
                vm.isCoverage = false;
                $scope.coverageMove = coverageMove;
                $scope.coverageSelect = function (attr) {
                    if(vm.elementOn.name == ''){
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAElement"));
                        return
                    }
                    if(vm.elementOn.item.lock){return}
                    toolbarStatus();
                    vm.isCoverage = attr;
                }
                function coverageMove(data){
                    if(vm.elementOn.item.lock){return}
                    var _seq = Number(vm.pages[vm.pageIndex].levels.level.length);
                    if(data == "up"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq == _seq){
                            MessageService.error($translate.instant("editorMessage.topLevel"));
                            return;
                        }
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq+1);
                        vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                            if(level.seq == seq){
                                level.seq--
                            }
                        })
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq++
                    }
                    if(data == "down"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq <2){
                            MessageService.error($translate.instant("editorMessage.bottomLevel"));
                            return;
                        }
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq-1);
                        vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                            if(level.seq == seq){
                                level.seq++
                            }
                        });
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq--
                    }
                    if(data == "top"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq == _seq){
                            MessageService.error($translate.instant("editorMessage.topLevel"));
                            return;
                        }
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq);
                        for (var i = 0; i < vm.pages[vm.pageIndex].levels.level.length; i++) {
                            if(vm.pages[vm.pageIndex].levels.level[i].seq > seq){
                                vm.pages[vm.pageIndex].levels.level[i].seq--;
                            }
                        }
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq = _seq
                    }
                    if(data == "bottom"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq == 0){
                            MessageService.error($translate.instant("editorMessage.bottomLevel"));
                            return;
                        }
        
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq);
                        for (var i = 0; i < vm.pages[vm.pageIndex].levels.level.length; i++) {
                            if(vm.pages[vm.pageIndex].levels.level[i].seq < seq){
                                vm.pages[vm.pageIndex].levels.level[i].seq+=1;
                            }
                        }
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq = 1;
                    }
        
                    var _seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq);
                    var _levelI = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq - 1;
                    vm.pages[vm.pageIndex].levels.level.sort(compare('seq', true));
                    for (var i = 0; i < vm.pages[vm.pageIndex].levels.level.length; i++) {
                        if(vm.pages[vm.pageIndex].levels.level[i].seq == _seq){
                            _levelI = i;
                            break
                        }
                    }
                    vm.elementOn.index = _levelI;
                    cookie();
                }
                function compare(property) {
                    return function (a, b) {
                        var value1 = a[property];
                        var value2 = b[property];
                        return value1 - value2;
                    }
                }
                //复制
                $scope.copyimg = vm.copyimg = function ($event) {
                    var all = getAllCtrlKeyArray();
                    if(!vm.clickNum){
                        vm.clickNum = 0;
                    }
                    vm.clickNum+=10;
                    if(all.length>0){
                        all.forEach(function (item) {
                            (function (item1) {
                                var _level = {
                                    seq: vm.pages[vm.pageIndex].levels.level.length + 1,
                                }
                                _level[item1.current] = angular.copy(item1);
                                _level[item1.current].lock = false;
                                _level[item1.current].ctrlKey = false;
                                _level[item1.current].geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                                _level[item1.current].geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                                vm.pages[vm.pageIndex].levels.level.push(_level);
                            })(item)
                        })
                    }else{
                        if(!vm.elementOn.item){return}
                        var _level = {
                            seq: vm.pages[vm.pageIndex].levels.level.length + 1
                        }
                        if(vm.elementOn.name == "imagebox"){
                            _level.imagebox = angular.copy(vm.elementOn.item);
                            _level.imagebox.lock = false;
                            _level.imagebox.geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                            _level.imagebox.geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(vm.elementOn.name == "imageart"){
                            _level.imageart = angular.copy(vm.elementOn.item);
                            _level.imageart.lock = false;
                            _level.imageart.geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                            _level.imageart.geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(vm.elementOn.name == "textbox"){
                            _level.textbox = angular.copy(vm.elementOn.item);
                            _level.textbox.lock = false;
                            _level.textbox.geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                            _level.textbox.geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        vm.pages[vm.pageIndex].levels.level.push(_level);
                    }
                    levelSeqSort(vm.pages[vm.pageIndex].levels.level);
                    cookie();
                }
                function levelSeqSort(levels){
                    if(levels){
                        var seq = 0;
                        levels.forEach(function(level){
                            level.seq = seq;
                            seq++
                        })
                        levels.sort(compare('seq', true));
                    }
                }
                
                vm.copyArray = {imageboxes: [], textboxes: [], imagearts: [], barcode: [], qrcode: [], textdocuments: []};
                // 复制元素
                vm.copyElement = function(){
                    if(vm.copyArray.imageboxes.length == 0 && vm.copyArray.imagearts.length == 0 && vm.copyArray.textboxes.length == 0){
                        return;
                    }
                    copyTogether();
                }

                // 多选调用
                function copyTogether(){
                    angular.forEach(vm.copyArray.imageboxes, function (imagebox, i) {
                        if(imagebox&&imagebox.geometry){
                            // 当前页所有占位框
                            var box = angular.copy(imagebox);
                            var _level = {
                                seq: vm.pages[vm.pageIndex].levels.level.length + 1
                            }
                            _level.imagebox = angular.copy(copyDetail(box));
                            vm.pages[vm.pageIndex].levels.level.push(_level)
                        }

                    })

                    angular.forEach(vm.copyArray.imagearts, function (imageart, i) {
                        if(imageart&&imageart.geometry){
                            if(imageart.serviceType){
                                return
                            }
                            // 当前页所有素材
                            var box = angular.copy(imageart);
                            var _level = {
                                seq: vm.pages[vm.pageIndex].levels.level.length + 1
                            }
                            _level.imageart = angular.copy(copyDetail(box));
                            vm.pages[vm.pageIndex].levels.level.push(_level)
                        }
                    })

                    angular.forEach(vm.copyArray.textboxes, function (textbox, i) {
                        if(textbox&&textbox.geometry){
                            // 当前页所有文字
                            var box = angular.copy(textbox);
                            var _level = {
                                seq: vm.pages[vm.pageIndex].levels.level.length + 1
                            }
                            _level.textbox = angular.copy(copyDetail(box));
                            vm.pages[vm.pageIndex].levels.level.push(_level)
                        }

                    })
                    levelSeqSort(vm.pages[vm.pageIndex].levels.level);
                }
                function copyDetail(box) {
                    box.levelI = vm.pages[vm.pageIndex].levels.level.length-1;
                    box.lock = false;
                    box.ctrlKey = false;
                    var repeatEle = false;
                    vm.pages[vm.pageIndex].levels.level.forEach(function(item){
                        if(item.imagebox && item.imagebox.geometry.x == box.geometry.x && item.imagebox.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                        if(item.imageart && item.imageart.geometry.x == box.geometry.x && item.imageart.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                        if(item.textbox && item.textbox.geometry.x == box.geometry.x && item.textbox.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                        if(item.code && item.code.geometry.x == box.geometry.x && item.code.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                    })
                    if(!repeatEle){
                        return box
                    }
                    // 复制上一次的位置
                    if (box.current == 'imagebox') {
                        vm.copyArray.imageboxes.forEach(function(imagebox){
                            if(imagebox && imagebox.geometry.x == box.geometry.x && imagebox.geometry.y == box.geometry.y){
                                var x = PxTurnMm(imagebox.geometry.x) + 1;
                                var y = PxTurnMm(imagebox.geometry.y) + 1;
                                imagebox.geometry.x = MmTurnPx(x);
                                imagebox.geometry.y = MmTurnPx(y);
                            }
                        })
                    }
                    if (box.current == 'imageart') {
                        vm.copyArray.imagearts.forEach(function(imageart){
                            if(imageart && imageart.geometry.x == box.geometry.x && imageart.geometry.y == box.geometry.y){
                                var x = PxTurnMm(imageart.geometry.x) + 1;
                                var y = PxTurnMm(imageart.geometry.y) + 1;
                                imageart.geometry.x = MmTurnPx(x);
                                imageart.geometry.y = MmTurnPx(y);
                            }
                        })
                    }
                    if(box.current == 'textbox'){
                        vm.copyArray.textboxes.forEach(function(textbox){
                            if(textbox && textbox.geometry.x == box.geometry.x && textbox.geometry.y == box.geometry.y){
                                var x = PxTurnMm(textbox.geometry.x) + 1;
                                var y = PxTurnMm(textbox.geometry.y) + 1;
                                textbox.geometry.x = MmTurnPx(x);
                                textbox.geometry.y = MmTurnPx(y);
                            }
                        })
                    }
                    // 新元素
                    var x = PxTurnMm(box.geometry.x) + 1;
                    var y = PxTurnMm(box.geometry.y) + 1;
                    box.geometry.x = MmTurnPx(x);
                    box.geometry.y = MmTurnPx(y);
                    return box
                }
                //裁切
                $scope.doubleClickImagebox = function (event) {
                    $rootScope.$broadcast('doubleClickImageboxCallback',{
                        event: event,
                        index: vm.elementOn.index,
                        item: vm.elementOn.item,
                        pageIndex: vm.elementOn.pageIndex,
                    });
                };
                //交换
                $scope.exchange = function () {
                    vm.pages[vm.pageIndex].levels.level.forEach(function (level, index) {
                        if(level.imagebox){
                            if(index!=vm.elementOn.index){
                                level.imagebox.exchange = true;
                            }else{
                                level.imagebox.exchange = false;
                            }
                        }
                    })
                };
                //智能抠图
                $scope.mattingOpen = function () {
                    if (!vm.elementOn || vm.elementOn.name !== 'imagebox' || !vm.elementOn.item) return;
                    $timeout(function(){
                        var div = document.getElementsByClassName('selected');
                        if (div.length > 0) {
                            var rect = div[0].getBoundingClientRect();
                            vm.imageboxCutout = {
                                image: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resource.identifier,
                                mattingMask: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.mattingMask,
                                resourceid: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resourceid,
                                x: rect.left,
                                y: rect.top,
                                width: rect.width,
                                height: rect.height,
                                angle: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.angle,
                                flip: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.flip,
                            }
                            vm.isShowImageCutout = true;
                        }
                    })
                };
                $scope.imageCutoutChange = function(text){
                    if(text){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resource.identifier = text.result;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.mattingMask = text.mattingMask;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.angle = text.angle;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.flip = text.flip;
                    }
                }
                $scope.imageCutoutSave = function(text){
                    vm.isShowImageCutout = false;
                    if(text){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resource.identifier = text.result;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.mattingMask = text.mattingMask;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.angle = text.angle;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.flip = text.flip;
                        if(vm.propertyValue.white && vm.propertyValue.white.length){
                            $scope.setProcessImages(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox);
                        }
                    }
                }
                // 大图判断
                $scope.isLarge = function(imageInfo){
                    if(!imageInfo)return
                    return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
                }
                /***********************  顶部操作end  ****************************/
                
                $scope.setProcessImages = function(imagebox){
                    if(imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier){
                        processImages(imagebox.image.resource.identifier,null,function(res){
                            var blob = base64ToBlob(res, 'image/' + imagebox.image.imageInfo.format);
                            var _file = blobToFile(blob); 
                            ImageService.backendUploadPics(_file, vm.domain, vm.token, function(data){
                                imagebox.whiteInk = null;
                                imagebox.whiteInk2 = {
                                    resource:{
                                        identifier:vm.domain +data.key
                                    },
                                    growMethod: vm.propertyValue.white[0].epitaxy,
                                    growValue: vm.propertyValue.white[0].epitaxyValue,
                                    unit: vm.propertyValue.white[0].unit,
                                    color: vm.propertyValue.white[0].spotColor,
                                    colorValue: vm.propertyValue.white[0].color,
                                };
                                $scope.$apply();
                            },function(err){
                                MessageService.error($translate.instant("pagePhoto.message.whiteInkSizeMismatch"));
                                $scope.$apply();
                            })
                        },function(error){
                            MessageService.error(error);
                        })
                    }else{
                        MessageService.error($translate.instant("pagePhoto.message.addImageFirst"));
                    }
                }

                vm.chalkItem = null;
                vm.chalkImageart = null;
                vm.chalkWidth = null;
                vm.chalkHeight = null;
                vm.chalkPropertyValue = null;
                $scope.editProcessImages = function(imagebox,propertyValue){
                    if(vm.menuIndex == 'uv' || vm.menuIndex == 'fluore'){
                        vm.chalkImageart = angular.copy($scope.getImageart(vm.pages[vm.pageIndex],vm.menuIndex,propertyValue) || {});
                        vm.chalkWidth = vm.pages[vm.pageIndex].mediabox.width;
                        vm.chalkHeight = vm.pages[vm.pageIndex].mediabox.height;
                        vm.chalkPropertyValue = propertyValue;
                        return
                    }else{
                        if(vm.propertyValue.white && vm.propertyValue.white.length){
                            vm.chalkPropertyValue = vm.propertyValue.white[0];
                        }
                    }
                    if(imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier){
                        vm.chalkItem = imagebox;
                        vm.chalkWidth = vm.chalkItem.image.imageInfo.width;
                        vm.chalkHeight = vm.chalkItem.image.imageInfo.height;
                    }else{
                        MessageService.error($translate.instant("pagePhoto.message.addImageFirst"));
                    }
                }
                $scope.deleteProcessImages = function(item){
                    var index = $scope.getImageart(vm.pages[vm.pageIndex],vm.menuIndex,item,true);
                    if(index >= 0){
                        vm.pages[vm.pageIndex].levels.level.splice(index, 1);
                        $scope.editorBodyView();
                    }
                }
                vm.chalkChange = function(text){
                    if(text){
                        if(vm.menuIndex == 'uv' || vm.menuIndex == 'fluore'){
                            var index = $scope.getImageart(vm.pages[vm.pageIndex],vm.menuIndex,vm.chalkPropertyValue,true);
                            if(index !== null && index > -1){
                                vm.pages[vm.pageIndex].levels.level[index].imageart = text;
                            }else{
                                vm.pages[vm.pageIndex].levels.level.push({
                                    seq: vm.pages[vm.pageIndex].levels.level.length+1,
                                    imageart: text
                                });
                            }
                        }
                    }
                    vm.chalkItem = null;
                    vm.chalkImageart = null;
                }
                $scope.goldFoil = function(color){
                    if(color){
                        return goldFoil(color)
                    }
                }
                $scope.getImageart = function(page,serviceType,propertyValue,isIndex){
                    var imageart = null;
                    if(page && page.levels && page.levels.level){
                        for(var i=0; i<page.levels.level.length; i++){
                            if(page.levels.level[i].imageart && page.levels.level[i].imageart.spotColor && page.levels.level[i].imageart.serviceType === serviceType && page.levels.level[i].imageart.spotColor.uuid == propertyValue.uuid){
                                if(isIndex){
                                    imageart = i;
                                }else{
                                    imageart = page.levels.level[i].imageart;
                                }
                                break
                            }
                        }
                    }
                    return imageart;
                }
                $scope.getImageartSize = function(type,propertyValue){
                    var imageart = $scope.getImageart(vm.pages[vm.pageIndex], vm.menuIndex, propertyValue);
                    if(imageart){
                        var size = 280;
                        if(imageart.geometry.width > imageart.geometry.height){
                            if(type == 'width'){
                                return size
                            }else{
                                return size * imageart.geometry.height / imageart.geometry.width
                            }
                        }else{
                            if(type == 'width'){
                                return size * imageart.geometry.width / imageart.geometry.height
                            }else{
                                return size
                            }
                        }
                    }
                }
                vm.isOutline = false;
                $scope.setOutline = function(){
                    vm.isOutline = true;
                }
                $scope.outlineChange = function(text){
                    vm.isOutline = false;
                    if(text){
                        vm.pages[vm.pageIndex].outline = text.outline;
                        vm.pages[vm.pageIndex].outlineSpread = text.outlineSpread;
                    }
                }
                //缩略图最长边尺寸
                var chalkViewSize = 146;
                $scope.chalkSize = function(imagebox,type){
                    if(!imagebox || !type){
                        return;
                    }
                    //白墨层由整张原图生成，预览要按图片自身比例缩放；geometry 是图片框（裁剪窗口），比例与图片可能不一致
                    var geometry = imagebox.geometry || {};
                    var image = imagebox.image || {};
                    var width = image.width1 || image.width || geometry.width;
                    var height = image.height1 || image.height || geometry.height;
                    var longSide = Math.max(width, height);
                    if(!longSide){
                        return;
                    }
                    return (type == 'width' ? width : height) * chalkViewSize / longSide;
                }
            }]
    };

    angular.module('editorApp')
        .component('pagePhoto', PagePhotoControl);

})();
